import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

export default function getDeliveryOptions(reference: string | undefined, deliveryId: number) {
    if (!reference) {
        return Promise.reject(new Error(shopErrors.referenceNotFound.message));
    }

    return shop
        .get(getUrl(`/baskets/deliveryoptions/${reference}/${deliveryId}`))
        .json<ShopTypes.DeliveryOptionsResponse>();
}
